<script>
import List, {
  Item,
  Graphic,
  Meta,
  Text,
  Label
} from '@smui/list';

 export let data;

 let paymentOptions = [
    {
      title: 'Hotově',
      value: 'hotove',
      disabled: false,
    },
    {
      title: 'Platební kartou - platební brána',
      value: 'platebniBrana',
      disabled: false,
    },
    {
      title: 'Převodem z účtu',
      value: 'prevod',
      disabled: false,
    },
  ];
  export let selected='';

  function isAllowedPayment(type, sett, conf) {
    if(conf=="prevodHotove" && (type=="hotove" || type=="prevod")) { conf=type; }
    else if(conf=="platebniBranaHotove" && (type=="hotove" || type=="platebniBrana")) { conf=type; }
    else if(conf=="platebniBranaPrevod" && (type=="platebniBrana" || type=="prevod")) { conf=type; }

    let value = true;
    if(sett==false) { value = false; }
    else if(conf=="") { value = true; }
    else if(conf!=type) { value = false; }
    if(selected=="" && value) { selected = type; }
    return value;
  }

</script>

{#await data}

{:then data}
 {#if data}
  <div>
    <List
      class="payment-select"
      singleSelection >
      {#each paymentOptions as item}

        {#if
            item.value=="hotove" && isAllowedPayment("hotove", data.config.payment.hotove, data.school.platba) ||
            item.value=="platebniBrana" && isAllowedPayment("platebniBrana", data.config.payment.platebniBrana, data.school.platba) ||
            item.value=="prevod" && isAllowedPayment("prevod", data.config.payment.prevod, data.school.platba)
        }
          <Item
            on:SMUI:action={() => (selected = item.value)}
            disabled={item.disabled}
            selected={selected === item.value}
          >
            <Text>
              {#if data.config.text[item.value]}
                {data.config.text[item.value]}
              {:else}
                {item.title}
              {/if}
            </Text>
          </Item>
        {/if}
      {/each}
    </List>
  </div>
{/if}
{/await}

<link rel="stylesheet" href="bare.css" />

<style>

:root {
  --mdc-theme-primary: #0d6efd;
}

* :global(.payment-select) {
    max-width: 600px;
  }
</style>
